import { API_BASE_URL } from '../../config'
import {
  FETCH_FAVORITES_REQUEST,
  FETCH_FAVORITES_SUCCESS,
  FETCH_FAVORITES_FAILURE,
  FETCH_DISLIKES_REQUEST,
  FETCH_DISLIKES_SUCCESS,
  FETCH_DISLIKES_FAILURE,
  SET_ACTIVE_TAB,
  CLEAR_RIGHT_SWIPES_REQUEST,
  CLEAR_RIGHT_SWIPES_SUCCESS,
  CLEAR_RIGHT_SWIPES_FAILURE,
  CLEAR_LEFT_SWIPES_REQUEST,
  CLEAR_LEFT_SWIPES_SUCCESS,
  CLEAR_LEFT_SWIPES_FAILURE
} from './favoritesActionTypes'

export const fetchFavorites = () => async (dispatch) => {
  const token = localStorage.getItem('auth_token')

  if (!token) {
    dispatch({ type: FETCH_FAVORITES_FAILURE, error: 'No authentication token found' })
    return
  }

  dispatch({ type: FETCH_FAVORITES_REQUEST })

  try {
    const res = await fetch(`${API_BASE_URL}/swipes/favorites/`, {
      headers: {
        'accept': 'application/json',
        'Authorization': `Token ${token}`,
      },
      credentials: 'include'
    })

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}))
      throw new Error(errorData.detail || 'Failed to fetch favorites')
    }

    const data = await res.json()
    dispatch({ type: FETCH_FAVORITES_SUCCESS, payload: data })
  } catch (error) {
    dispatch({
      type: FETCH_FAVORITES_FAILURE,
      error: error.message || 'An error occurred while fetching favorites'
    })
  }
}

export const fetchDislikes = () => async (dispatch) => {
  const token = localStorage.getItem('auth_token')

  if (!token) {
    dispatch({ type: FETCH_DISLIKES_FAILURE, error: 'No authentication token found' })
    return
  }

  dispatch({ type: FETCH_DISLIKES_REQUEST })

  try {
    const res = await fetch(`${API_BASE_URL}/swipes/dislikes/`, {
      headers: {
        'accept': 'application/json',
        'Authorization': `Token ${token}`,
      },
      credentials: 'include'
    })

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}))
      throw new Error(errorData.detail || 'Failed to fetch disliked posts')
    }

    const data = await res.json()
    dispatch({ type: FETCH_DISLIKES_SUCCESS, payload: data })
  } catch (error) {
    dispatch({
      type: FETCH_DISLIKES_FAILURE,
      error: error.message || 'An error occurred while fetching disliked posts'
    })
  }
}

export const setActiveTab = (tab) => ({
  type: SET_ACTIVE_TAB,
  payload: tab
})

export const clearRightSwipes = () => async (dispatch) => {
  const token = localStorage.getItem('auth_token')

  if (!token) {
    dispatch({ type: CLEAR_RIGHT_SWIPES_FAILURE, error: 'No authentication token found' })
    return
  }

  dispatch({ type: CLEAR_RIGHT_SWIPES_REQUEST })

  try {
    const res = await fetch(`${API_BASE_URL}/swipes/clear_right_swipes/`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Token ${token}`,
      },
      credentials: 'include'
    })

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}))
      throw new Error(errorData.detail || 'Failed to clear right swipes')
    }

    dispatch({ type: CLEAR_RIGHT_SWIPES_SUCCESS })
    dispatch(fetchFavorites()) // Refresh the favorites list
  } catch (error) {
    dispatch({
      type: CLEAR_RIGHT_SWIPES_FAILURE,
      error: error.message || 'An error occurred while clearing right swipes'
    })
  }
}

export const clearLeftSwipes = () => async (dispatch) => {
  const token = localStorage.getItem('auth_token')

  if (!token) {
    dispatch({ type: CLEAR_LEFT_SWIPES_FAILURE, error: 'No authentication token found' })
    return
  }

  dispatch({ type: CLEAR_LEFT_SWIPES_REQUEST })

  try {
    const res = await fetch(`${API_BASE_URL}/swipes/clear_left_swipes/`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Token ${token}`,
      },
      credentials: 'include'
    })

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}))
      throw new Error(errorData.detail || 'Failed to clear left swipes')
    }

    dispatch({ type: CLEAR_LEFT_SWIPES_SUCCESS })
    dispatch(fetchDislikes()) // Refresh the dislikes list
  } catch (error) {
    dispatch({
      type: CLEAR_LEFT_SWIPES_FAILURE,
      error: error.message || 'An error occurred while clearing left swipes'
    })
  }
}
